import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = ({ 
  items = [],
  separator = 'ChevronRight',
  className = ""
}) => {
  const navigate = useNavigate();

  // Default breadcrumb structure if none provided
  const defaultItems = [
    { label: 'Dashboard', path: '/provider-dashboard', clickable: true },
    { label: 'Current Page', path: null, clickable: false }
  ];

  const breadcrumbItems = items?.length > 0 ? items : defaultItems;

  const handleItemClick = (item) => {
    if (item?.clickable && item?.path) {
      navigate(item?.path);
    }
  };

  if (breadcrumbItems?.length <= 1) {
    return null;
  }

  return (
    <nav 
      className={`flex items-center space-x-2 text-sm ${className}`}
      aria-label="Breadcrumb navigation"
    >
      <ol className="flex items-center space-x-2">
        {breadcrumbItems?.map((item, index) => {
          const isLast = index === breadcrumbItems?.length - 1;
          const isClickable = item?.clickable && item?.path && !isLast;

          return (
            <li key={index} className="flex items-center space-x-2">
              {/* Breadcrumb Item */}
              {isClickable ? (
                <button
                  onClick={() => handleItemClick(item)}
                  className="text-primary hover:text-primary/80 transition-colors duration-150 font-medium"
                  aria-label={`Navigate to ${item?.label}`}
                >
                  {item?.label}
                </button>
              ) : (
                <span 
                  className={`
                    ${isLast 
                      ? 'text-foreground font-medium' 
                      : 'text-muted-foreground'
                    }
                  `}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item?.label}
                </span>
              )}
              {/* Separator */}
              {!isLast && (
                <Icon 
                  name={separator} 
                  size={16} 
                  color="var(--color-muted-foreground)"
                  className="flex-shrink-0"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbTrail;